import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { AdvertiserMarginSchema } from '../../../../../../../schemas/ProjectManager/MarginSchema'
import axiosService from '../../../../../../../utils/AxiosService'
import { currencyFormat } from '../../../../../../../utils/Helper'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function AdvertiserMarginColumn({ campaignScenario, actionGroup, actions }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { campaign, primaryScenarioId } = useContext(CampaignContext)
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeMargin = advertiser_margin => {
    if(currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitMargin(advertiser_margin), 1000))
  }

  const submitMargin = advertiser_margin => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/campaign_scenario_action_groups/${actionGroup.id}`, { campaign_scenario_action_group: { advertiser_margin }})
    .then((updatedActionGroup) => {
      toastSuccess('Margin updated')
      actionGroup.advertiser_margin = updatedActionGroup.advertiser_margin
      campaignScenario.actions.filter(action => action.campaign_scenario_action_group_id === actionGroup.id).forEach(action => action.advertiser_margin = updatedActionGroup.advertiser_margin)
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  const advertiserMarginPrice = useMemo(() => actions.reduce((result, action) => result + action.advertiserMarginPrice, 0))

  return (
    <div className="col-span-2 p-2 flex justify-between items-center">
      <div>
        <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Advertiser Margin</p>
        <p className="font-bold text-sm dark:text-white">{currencyFormat(advertiserMarginPrice.toFixed(2), campaign.currency_symbol)}</p>
      </div>
      <Formik
        key={actionGroup.advertiser_margin}
        initialValues={{ advertiser_margin: actionGroup.advertiser_margin }}
        validationSchema={AdvertiserMarginSchema}
        onSubmit={changeMargin}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form className="w-2/5">
            <div className="relative -mt-2">
              <Input
                disabled={readOnly}
                addon="%"
                addonPosition="end"
                error={touched.advertiser_margin && errors.advertiser_margin}
                name="advertiser_margin"
                noLabelPadding
                onChange={(e) => {
                  changeMargin(e.target.value)
                  handleChange(e)
                }}
                onBlur={handleBlur}
                value={values.advertiser_margin}
                overrideClassName="h-7"
                topMargin="mt-1"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})